import React from 'react';
import { useSelector } from 'react-redux';
import { seoStateSelector } from '@stencil/flights-seo-reducers/src/SRP/redux/selectors';
import AirlineContactInfo from '@stencil/commonstories/src/components/Seo/airline-contact-info/airline-contact-info';
import SeoSrpCarousel from '../srp-card/seo-srp-carousel';
import ListForLinks from '@stencil/commonstories/src/components/Seo/list-for-links/list-for-links';

const SeoAirlinesLeft = props => {
  const seoState = useSelector(seoStateSelector);
  const {
    offers,
    airlineInfo,
    domesticRoutes,
    domAirlines,
    internationalRoutes,
    airlineDomRoutes,
    airlineIntlRoutes
  } = seoState;

  const { airline_contact_info_html: airlineContact, name: airlineName } = airlineInfo;

  return (
    <>
      <SeoSrpCarousel offers={offers} />
      {(airlineContact && <AirlineContactInfo longDesc={airlineContact} isDweb={true} />) || null}
      {(domAirlines && (
        <ListForLinks title="Top Airlines" html={domAirlines.api_url} links={[]} isDweb={true} />
      )) ||
        null}
      {(airlineDomRoutes && airlineDomRoutes.length > 0 && (
        <ListForLinks
          title={`${airlineName} Domestic Routes`}
          links={airlineDomRoutes}
          isDweb={true}
        />
      )) ||
        null}
      {(airlineIntlRoutes && airlineIntlRoutes.length > 0 && (
        <ListForLinks
          title={`${airlineName} International Routes`}
          links={airlineIntlRoutes}
          isDweb={true}
        />
      )) ||
        null}
      {(domesticRoutes && domesticRoutes.length > 0 && (
        <ListForLinks title={`Top Domestic Routes`} links={domesticRoutes} isDweb={true} />
      )) ||
        null}
      {(internationalRoutes && internationalRoutes.length > 0 && (
        <ListForLinks
          title={`Top International Routes`}
          links={internationalRoutes}
          isDweb={true}
        />
      )) ||
        null}
    </>
  );
};

export default SeoAirlinesLeft;
